import { classes } from '@theme/constants';
import { scrollIntoViewInContainer, throttle } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

class PageAnchors extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on(
      'scroll',
      window,
      throttle(
        () => {
          const { top } = this.getBoundingClientRect();
          const headerHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) ?? 0;
          const buffer = 32;
          const pageAnchors = document.querySelector('page-anchors');
          let pageAnchorsHeight = 0;

          if (pageAnchors) {
            pageAnchorsHeight = pageAnchors.refs.container.offsetHeight;
          }

          if (top + this.offsetHeight <= headerHeight) {
            if (!this.classList.contains(classes.active)) {
              this.style.height = `${this.refs.container.offsetHeight}px`;
            }

            setTimeout(() => {
              this.classList.add(classes.active);
            });
          } else {
            this.style.height = '';
            this.classList.remove(classes.active);
          }

          /**
           * Anchors.
           */
          for (const link of this.refs.link.all) {
            if (link.hash) {
              const section = document.querySelector(link.hash);

              if (section) {
                const isActive = section.getBoundingClientRect().top <= headerHeight + pageAnchorsHeight + buffer;

                if (isActive) {
                  this.currentAnchorLink = link;
                }
              }
            }
          }

          for (const link of this.refs.link.all) {
            const isActive = this.currentAnchorLink === link;

            if (isActive) {
              if (link.classList.contains(classes.active)) return;

              link.classList.add(classes.active);

              scrollIntoViewInContainer(link, link.parentElement.parentElement, 'smooth');
            } else {
              link.classList.remove(classes.active);
            }
          }
        },
        100,
        true,
      ),
      null,
      true,
    );

    this.on('click', this.refs.link.all, (event) => {
      const target = event.target.hash && document.querySelector(event.target.hash);

      if (target) {
        event.preventDefault();

        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
}

if (!customElements.get('page-anchors')) customElements.define('page-anchors', PageAnchors);
